import { Linking } from 'react-native';

import { openExternalLink } from './inAppBrowser';

export function isHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url.trim());
}

const MAILTO_HREF = /^mailto:[^\s<>"]+$/i;

/** Open a rich-content href the same way Cookies policy / Support do. */
export function openRichContentLink(url: string): void {
  const trimmed = url.trim();
  if (isHttpUrl(trimmed)) {
    void openExternalLink(trimmed);
    return;
  }
  if (MAILTO_HREF.test(trimmed)) {
    void Linking.openURL(trimmed);
  }
}
